/* LIBRAIRIES */ 
import React, { useState, useEffect } from 'react';

/* FIREBASE */
import { auth } from '../../firebase'; //importer votre instance firebase

/* COMPONENTS */
import UploadFile from '../../Components/UploadFile/UploadFile';
import UserList from '../../Components/UserList/UserList';
import UserDocs from '../../Components/UserDocs/UserDocs';
import NewUser from '../../Components/NewUser/NewUser';

/* CONTEXT */
import { useUserContext } from '../../useContext';

/* CSS */
import './Dashboard.css';

/* ICONS */
import { MdOutlineDocumentScanner } from 'react-icons/md';
import { AiFillDropboxSquare, AiFillFacebook, AiOutlineUsergroupAdd } from 'react-icons/ai';
import { FiUsers } from 'react-icons/fi';
import { BsLinkedin, BsInstagram } from 'react-icons/bs';

/* LOADER */
import { Triangle } from 'react-loader-spinner';

const Dashboard = () => {

    const [elementSelected, setElementSelected] = useState('documents');
    const [userId, setUserId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const { userRole, userInfos } = useUserContext(); // récupération de la valeur userRole depuis le contexte

    useEffect(() => {
        const fetchUser = async () => {
            const user = auth.currentUser;
            if (user) {
              // L'utilisateur est connecté
              const userId = user.uid;
              setUserId(userId);
              setIsLoading(false);
              console.log("L'utilisateur connecté a l'ID:", userId);
            } else {
              // Aucun utilisateur n'est actuellement connecté
              console.log('Aucun utilisateur connecté');
              setIsLoading(false);
            }
        }
        fetchUser();
    }, [])

    return (
        <div className='container-page-dashboard'>
            <div className='container-menu-dashboard'>
                <h2 className='userdocs-title'>Utilisateur : {userInfos?.firstName} {userInfos?.name}</h2>
                <ul>
                    { (userRole === 'admin' || userRole === 'collaborateur') && <li onClick={() => setElementSelected('users')} className={elementSelected == 'users' && 'active'}><FiUsers />Liste Utilisateurs</li> }
                    <li onClick={() => setElementSelected('documents')} className={elementSelected == 'documents' && 'active'}><MdOutlineDocumentScanner />Mes documents</li>
                    <li onClick={() => setElementSelected('drop')} className={elementSelected == 'drop' && 'active'}><AiFillDropboxSquare />Dépose</li>
                </ul>
            </div>
            {
                elementSelected === 'drop' && userId && <UploadFile userId={userId} />
            }
            {
                elementSelected === 'users' && (userRole === 'admin' || userRole === 'collaborateur')  && <UserList />
            }
            {
                elementSelected === 'documents' && userId && <UserDocs userId={userId} userInfos={userInfos}/>
            }
            {
                isLoading &&
                <Triangle
                    height="80"
                    width="80"
                    color="#4fa94d"
                    ariaLabel="triangle-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                />
            }
        </div>
    )
}

export default Dashboard